import { device } from "helpers/_device";

import trans from "helpers/_translation";

export const getAuthenticationForm = (type = "login") => {
	const fields = [
		{
			"type": "EmailField",
			"name": "username",
			"label": "E-mailadres",
			"required": true,
			"autocomplete": "email",
			"data": {
				"colclass": "span12"
			}

		}
	];
	if (type !== "forget") {
		fields.push({
			"type": "PasswordField",
			"name": "password",
			"label": "Wachtwoord",
			"required": type === "login",
			"autocomplete": "password",
			"data": {
				"colclass": "span12"
			}
		});
	}
	return fields;
};

export const getPasswordResetForm = () => {
	const fields = [
		{
			"type": "PasswordField",
			"name": "new_password",
			"label": "Nieuw wachtwoord",
			"required": true,
			"autocomplete": "none",
			"data": {
				"colclass": "span12"
			}
		},
		{
			"type": "PasswordField",
			"name": "confirm_password",
			"label": "Bevestig wachtwoord",
			"required": true,
			"autocomplete": "none",
			"data": {
				"colclass": "span12"
			}
		}
	];
	return fields;
};